import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import {
  useApiPortalV1AssessmentsPlansOrganizationListQuery,
  useApiPortalV1AssessmentsPlansTasksListQuery,
} from 'areas/assessment-schedule/api';

import { PageContent, PageSection } from 'common/styles/page';

import TeamProjectHeader from './TeamProjectHeader';
import TeamActionPlan from './TeamActionPlan';
import { useSelector } from 'react-redux';
import LoadingSpinner from 'common/components/LoadingSpinner';
import { getCurrentOrganizationId, getMostRecentAssessmentPeriodId, getSelectedAssessmentPeriodId } from 'common/selectors/auth';

import TopBarControls from 'common/layouts/AuthLayout/TopBarAssessmentPeriod';
import { TopBarContext } from 'common/layouts/AuthLayout/TopBarContext';

const TeamProject: React.FC<{ actionPlanId?: number }> = ({ actionPlanId }) => {
  const [taskData, setTaskData] = useState<any[]>([]);
  const [actionPlanData, setActionPlanData] = useState<any[]>([]);
  const [isLoaded, setIsLoaded] = useState(false);

  const { setTopBarContent } = useContext(TopBarContext);
  const organizationId = useSelector(getCurrentOrganizationId);

  const { id } = useParams();
  const action_plan_id = actionPlanId !== undefined ? actionPlanId : (Number(id) || 0);

  const assessmentPeriodId = useSelector(getSelectedAssessmentPeriodId);

  const { data: task_data } = useApiPortalV1AssessmentsPlansTasksListQuery({
    assessmentPeriodActionPlanId: action_plan_id,
  });
  const { data: action_plan_data } = useApiPortalV1AssessmentsPlansOrganizationListQuery({
    assessmentPeriodId: assessmentPeriodId,
    assessmentPeriodActionPlanId: action_plan_id,
  });

  useEffect(() => {
    if (task_data  && action_plan_data) {
      setIsLoaded(true);
    }
    if (task_data) {
      setTaskData(task_data);
    }
    if (action_plan_data) {
      setActionPlanData(action_plan_data);
    }
  }, [task_data, action_plan_data]);


  /*  TP: todo-- team leaders need to be able to see the projects from past APs. Need to find their previous action plan id
  useEffect(() => {
    setTopBarContent(<TopBarControls />);
    return () => setTopBarContent(null);
  }, [setTopBarContent, organizationId]);
 */

  if (!isLoaded) {
    return <LoadingSpinner />;
  }

  return (
    <PageContent>
      <PageSection padbottom>
        <TeamProjectHeader team_id={actionPlanData?.[0]?.team} />
        <PageSection padtop>
          <TeamActionPlan taskData={taskData} actionPlanId={action_plan_id} />
        </PageSection>
      </PageSection>
    </PageContent>
  );
};
export default TeamProject;
